import React from "react";
import { Card } from "../../components/ui";
import { AuthArt } from "../../assets/illustrations";

export default function AuthCard({ title, subtitle, children, footer }) {
  return (
    <Card glass className="auth-card">
      <AuthArt className="auth-card__art" />
      <h1 style={{ fontSize: 24 }}>{title}</h1>
      {subtitle ? <p className="muted mt-8 mb-16">{subtitle}</p> : <div className="mb-16" />}
      {children}
      {footer ? <div className="center mt-16 muted" style={{ fontSize: 14 }}>{footer}</div> : null}
    </Card>
  );
}
